import { OWHErrorType, ErrorBase } from '@fluidx/office-fluid-types';

export function isIframeLoadFailedError(error: ErrorBase<OWHErrorType>) {
  return error.name === OWHErrorType.IframeLoadFailed;
}

export function isComponentNotFoundError(error: ErrorBase<OWHErrorType>) {
  return error.name === OWHErrorType.ComponentNotFound;
}

/**
 * Match a error against known office web host error types
 * @param error potential container error
 * @returns ContainerErrorType in case of a match
 */
export function tryMatchOWHErrorType(error: unknown): OWHErrorType | undefined {
  if (typeof error === 'object') {
    const typedError = error as ErrorBase<OWHErrorType>;

    if (isIframeLoadFailedError(typedError)) {
      return OWHErrorType.IframeLoadFailed;
    }
    if (isComponentNotFoundError(typedError)) {
      return OWHErrorType.ComponentNotFound;
    }

    // ... try match any other known OWH error types
  }

  return;
}
